// Selected facts and original media from the school's public pages, audited 2026-10-05.
// See research/content-audit-programs.json for source URLs, full inventory and cautions.
export const coaches = [
  {
    name: 'Master Chee Bates',
    role: 'Owner & head coach',
    credential: '4th Dan Kukkiwon',
    bio: 'More than 25 years of coaching experience. A USA Taekwondo Level 2 and AAU certified coach, with experience coaching athletes internationally.',
    image: 'https://static.wixstatic.com/media/37c34b_be8fe0cc43c2441bb23b7f7b147b883f~mv2.jpg/v1/fill/w_204,h_448,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/chee%20pic%20.jpg',
  },
  {
    name: 'Page Bates',
    role: 'Coach',
    credential: '3rd degree black belt',
    bio: 'Competing since 2004 and a black belt since 2008. A US Open medalist who served as kicking coach for two Jon Jones camps.',
    image: 'https://static.wixstatic.com/media/61e59f_37f5fba21ed14ce5a207a9a9807160bf~mv2.jpg/v1/crop/x_670,y_110,w_783,h_790/fill/w_301,h_303,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Page%20%26%20Jessie.jpg',
  },
  {
    name: 'Chaney Cecil',
    role: 'Instructor & competitor',
    credential: '3rd degree black belt',
    bio: 'Training since 2012. Won senior and Under-21 gold at the 2026 U.S. Nationals and represented Team USA at international championships.',
    image: 'https://static.wixstatic.com/media/37c34b_623e6570a9004682ba91affed10e4f76~mv2.jpg/v1/fill/w_343,h_446,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Chaney%20pic%20Nationals.jpg',
  },
  {
    name: 'Ryan Araujo',
    role: 'Coaching team',
    credential: '3rd degree black belt',
    bio: 'Started training in 2015 and earned a black belt in 2020. Competition experience includes the 2025 AAU B Team.',
    image: 'https://static.wixstatic.com/media/37c34b_cb6d452fd55e4931a51290241fd66cfa~mv2.jpg/v1/fill/w_267,h_334,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/ryan.jpg',
  },
  {
    name: 'Cooper Cecil',
    role: 'Coaching team',
    credential: '3rd degree black belt',
    bio: 'Training since 2012 and competing since 2014. His results include national and US Open medals, plus 2024 AAU Regional silver.',
    image: 'https://static.wixstatic.com/media/61e59f_1ff768c73c174bcc8466fefd053a4d7f~mv2.jpg/v1/fill/w_301,h_298,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/cooper.jpg',
  },
  {
    name: 'Mattie Araujo',
    role: 'Coaching team',
    credential: '',
    bio: '',
    image: 'https://static.wixstatic.com/media/37c34b_239be6cea37b4e15bbaa583c2bfc1c33~mv2.jpg/v1/fill/w_341,h_241,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/mattie.jpg',
  },
] as const;

interface PoomsaeResource {
  name: string;
  requirement: string;
  note?: string;
  youtubeId?: string;
  videoUrl?: string;
  poster?: string;
}

export const poomsaeResources: PoomsaeResource[] = [
  { name: 'Taegeuk Il Jang', requirement: 'Yellow → orange', note: 'Also practiced by white, yellow and orange belts.', youtubeId: 'wcFAyyOxz5o' },
  { name: 'Taegeuk Yi Jang', requirement: 'Orange → green', youtubeId: 'k-2lkShsJuM' },
  { name: 'Taegeuk Sam Jang', requirement: 'Green → green stripe', youtubeId: 'I6BnOEL_1bs' },
  { name: 'Taegeuk Sah Jang', requirement: 'Green stripe → blue', youtubeId: 'U28aZcO1MC4' },
  { name: 'Taegeuk Oh Jang', requirement: 'Blue → blue stripe', youtubeId: '4sdn0XH9pCo' },
  { name: 'Taegeuk Yuk Jang', requirement: 'Blue stripe → red', youtubeId: '0ZT7-osLbmE' },
  {
    name: 'Taegeuk Chil Jang', requirement: 'Red → red stripe',
    videoUrl: 'https://video.wixstatic.com/video/37c34b_7b6032a8b6e645948848155742f520bc/480p/mp4/file.mp4',
    poster: 'https://static.wixstatic.com/media/37c34b_7b6032a8b6e645948848155742f520bcf000.jpg/v1/fill/w_370,h_489,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/37c34b_7b6032a8b6e645948848155742f520bcf000.jpg',
  },
  { name: 'Taegeuk Pal Jang', requirement: 'Red stripe → black', youtubeId: 'cO5_XvmPHDY' },
  { name: 'Koryo', requirement: 'Black belt test', youtubeId: '_HC3Wls3rv4' },
  { name: 'Keumgang', requirement: '2nd degree test', youtubeId: 'j9L9QOvDc2U' },
  { name: 'Taebaek', requirement: '3rd degree black belt', youtubeId: 'rVrsu8Q_TwY' },
  { name: 'Pyongwon', requirement: '4th degree test · Master', youtubeId: '6Iwy64DGRCY' },
  { name: 'Sipjin', requirement: '5th degree', youtubeId: 'wzL69MuZ-4o' },
];
